export const sxBackBtn = {
  display: { xs: 'flex', md: 'none' },
  mr: 1,
};

export const sxButton = {
  px: '22px',
  py: '11px',
  width: 1,
};
